import React from 'react'
import { css } from '@emotion/css'
import { useIntl } from 'react-intl'
import { getSeverityData } from '../cell-content/vulnerabilities-cell'
import { VulnerabilitiesTooltip } from '../cell-content/vulnerabilities-tooltip'
import { CvssScoringType } from '../../helpers/ui-interfaces'
import { Vulnerability } from '../../../../components/shared'
import {
  Modal,
  ModalBody,
  ModalFooter
} from '@contrast-security-inc/design-system-popovers'
import { Button } from '@contrast-security-inc/design-system-buttons'

interface Props {
  isOpen: boolean
  closeModal: () => void
  dependencyName: string
  dependencyVersion: string
  vulnerabilities: Vulnerability[]
  setModalVulnerability: React.Dispatch<
    React.SetStateAction<Vulnerability | undefined>
  >
  setLibraryVulnerabilityIsModalOpen: () => void
  cvssScoringType?: CvssScoringType
}

export const CveModal = ({
  isOpen,
  closeModal,
  dependencyName,
  dependencyVersion,
  vulnerabilities,
  setModalVulnerability,
  setLibraryVulnerabilityIsModalOpen,
  cvssScoringType
}: Props) => {
  const { formatMessage } = useIntl()

  return (
    <Modal
      variant="info"
      isOpen={isOpen}
      onClose={closeModal}
      title={formatMessage(
        {
          id: 'title_library_nameVersion'
        },
        {
          libraryName: dependencyName,
          libraryVersion: dependencyVersion
        }
      )}
      size="md"
    >
      <ModalBody>
        <div>
          <div
            className={css`
              margin-bottom: 15px;
            `}
            data-testid="dependency-cve-modal"
          >
            {formatMessage(
              { id: 'detail_libraries_numberOfVulnerabilities' },
              { numberOfVulnerabilities: vulnerabilities.length }
            )}
          </div>
          <VulnerabilitiesTooltip
            severityData={getSeverityData(vulnerabilities, cvssScoringType)}
            setIsModalOpen={setLibraryVulnerabilityIsModalOpen}
            setModalVulnerability={setModalVulnerability}
            cvssScoringType={cvssScoringType}
          />
        </div>
      </ModalBody>
      <ModalFooter>
        <Button onClick={closeModal}>
          {formatMessage({ id: 'action_done' })}
        </Button>
      </ModalFooter>
    </Modal>
  )
}
